<div class="rating">
    <div class="p-4" [ngClass]="{'excellent': rating >= 4,
        'average': rating >2 && rating < 4,     
        'poor': rating <=2 }">
        <i class="fa fa-star" aria-hidden="true"></i>
        <span>{{ rating | number:'1.1-1' }}</span>
    </div>
</div>